export default "__VITE_ASSET__C7Ijqez7__"